import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    icon: {
        color: theme.palette.grey[600],
    },
}));
